var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconApiEndpoints01 = function SvgIconApiEndpoints01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10.53,
    y1: 91.91,
    x2: 96.05,
    y2: 18.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -10.53,
    y1: 91.91,
    x2: 96.05,
    y2: 18.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -10.53,
    y1: 91.91,
    x2: 96.05,
    y2: 18.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -13.07,
    y1: 88.24,
    x2: 93.51,
    y2: 14.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -5.97,
    y1: 98.5,
    x2: 100.61,
    y2: 24.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -22.26,
    y1: 74.96,
    x2: 84.32,
    y2: 1.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -11.68,
    y1: 90.26,
    x2: 94.9,
    y2: 16.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.65,
    y1: 106.18,
    x2: 105.93,
    y2: 32.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -10.77,
    y1: 91.56,
    x2: 95.81,
    y2: 17.78,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.31,60.58l-3.45-1.99c.58-2.88.87-5.77.87-8.59s-.29-5.75-.86-8.6l3.43-1.98c1.06-.61,1.82-1.61,2.14-2.79s.15-2.43-.46-3.49l-9.39-16.27c-.61-1.06-1.61-1.82-2.79-2.14-1.19-.32-2.43-.15-3.49.46l-3.44,1.98c-4.34-3.82-9.45-6.78-14.89-8.62v-3.95c0-2.54-2.06-4.6-4.6-4.6h-18.79c-2.54,0-4.6,2.06-4.6,4.6v3.95c-5.41,1.83-10.51,4.79-14.87,8.63l-3.46-2c-1.06-.61-2.3-.78-3.49-.46-1.19.32-2.18,1.08-2.79,2.14L2,33.13c-.61,1.06-.78,2.3-.46,3.49s1.08,2.18,2.14,2.79l3.45,1.99c-.58,2.88-.87,5.77-.87,8.59s.29,5.75.86,8.6l-3.43,1.98c-2.2,1.27-2.95,4.09-1.68,6.28l9.39,16.27c1.27,2.2,4.09,2.95,6.28,1.68l3.44-1.98c4.34,3.82,9.45,6.78,14.89,8.62v3.95c0,2.54,2.06,4.6,4.6,4.6h18.79c2.54,0,4.6-2.06,4.6-4.6v-3.95c5.41-1.83,10.51-4.79,14.87-8.63l3.46,2c2.2,1.27,5.01.51,6.28-1.68l9.39-16.27c1.27-2.2.51-5.01-1.68-6.28ZM95.46,65.4l-9.39,16.27c-.46.79-1.48,1.07-2.27.61l-4.38-2.53c-.56-.32-1.26-.24-1.73.19-4.48,4.14-9.87,7.27-15.59,9.04-.61.19-1.03.76-1.03,1.4v5.02c0,.92-.75,1.66-1.66,1.66h-18.79c-.92,0-1.66-.75-1.66-1.66v-5.02c0-.64-.42-1.21-1.03-1.4-5.75-1.78-11.15-4.9-15.61-9.03-.28-.26-.64-.39-1-.39-.25,0-.5.06-.73.2l-4.36,2.52c-.79.46-1.81.19-2.27-.61l-9.39-16.27c-.46-.79-.19-1.81.61-2.27l4.36-2.52c.56-.32.84-.97.7-1.59-.67-2.98-1.01-6.01-1.01-9.01s.35-5.99,1.03-9.01c.14-.63-.14-1.27-.7-1.59l-4.37-2.53c-.38-.22-.66-.58-.77-1.01-.11-.43-.06-.88.17-1.26l9.39-16.27c.22-.38.58-.66,1.01-.77.43-.12.88-.06,1.26.17l4.38,2.53c.56.32,1.26.24,1.73-.19,4.48-4.14,9.87-7.27,15.59-9.04.61-.19,1.03-.76,1.03-1.4v-5.02c0-.92.75-1.66,1.66-1.66h18.79c.92,0,1.66.75,1.66,1.66v5.02c0,.64.42,1.21,1.03,1.4,5.75,1.78,11.15,4.9,15.61,9.03.47.44,1.17.52,1.73.19l4.36-2.52c.38-.22.83-.28,1.26-.17.43.12.79.39,1.01.77l9.39,16.27c.22.38.28.83.17,1.26s-.39.79-.77,1.01l-4.36,2.52c-.56.32-.84.97-.7,1.59.67,2.98,1.01,6.01,1.01,9.01s-.35,5.99-1.03,9.01c-.14.63.14,1.27.7,1.59l4.37,2.53c.79.46,1.07,1.48.61,2.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,20.35c-16.35,0-29.65,13.3-29.65,29.65s13.3,29.65,29.65,29.65,29.65-13.3,29.65-29.65-13.3-29.65-29.65-29.65ZM50,76.71c-14.73,0-26.71-11.98-26.71-26.71s11.98-26.71,26.71-26.71,26.71,11.98,26.71,26.71-11.98,26.71-26.71,26.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.48,42.27h-5.48c-.81,0-1.47.66-1.47,1.47v12.52c0,.81.66,1.47,1.47,1.47s1.47-.66,1.47-1.47v-3.23h4.01c2.97,0,5.38-2.41,5.38-5.38s-2.41-5.38-5.38-5.38ZM55.48,50.1h-4.01v-4.89h4.01c1.35,0,2.45,1.1,2.45,2.45s-1.1,2.45-2.45,2.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.98,43.22c-.21-.57-.76-.95-1.37-.95h-1.57c-.61,0-1.16.38-1.37.95l-4.7,12.52c-.28.76.1,1.6.86,1.89.76.28,1.6-.1,1.89-.86l.82-2.18h6.58l.82,2.18c.22.59.78.95,1.37.95.17,0,.35-.03.52-.09.76-.28,1.14-1.13.86-1.89l-4.7-12.52ZM37.64,51.66l2.19-5.83,2.19,5.83h-4.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.09,42.27c-.81,0-1.47.66-1.47,1.47v12.52c0,.81.66,1.47,1.47,1.47s1.47-.66,1.47-1.47v-12.52c0-.81-.66-1.47-1.47-1.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M60.5,17.08c1.02.32,2.03.7,3.02,1.12.19.08.38.12.57.12.57,0,1.11-.34,1.35-.89.32-.75-.03-1.61-.78-1.93-1.07-.45-2.17-.86-3.28-1.22-.77-.25-1.6.18-1.84.95-.25.77.18,1.6.95,1.84Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.66,66.52c-.39-.71-1.28-.97-1.99-.59-.71.39-.97,1.28-.59,1.99.61,1.12,1.28,2.21,2,3.26.28.41.74.64,1.21.64.29,0,.58-.08.83-.26.67-.46.84-1.37.38-2.04-.66-.97-1.29-1.98-1.85-3.01Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.99,84.41c-7.86-.68-15.33-4.09-21.02-9.6-.58-.56-1.51-.55-2.08.03-.56.58-.55,1.51.03,2.08,6.17,5.98,14.28,9.68,22.81,10.41.04,0,.09,0,.13,0,.75,0,1.39-.58,1.46-1.34.07-.81-.53-1.52-1.34-1.59Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.12,19.04c-.67-.46-1.58-.29-2.04.38-.46.67-.29,1.58.38,2.04,6.82,4.66,11.75,11.59,13.89,19.53.18.65.77,1.09,1.42,1.09.13,0,.25-.02.38-.05.78-.21,1.25-1.02,1.04-1.8-2.32-8.61-7.67-16.13-15.07-21.19Z"
  })));
};
export default SvgIconApiEndpoints01;